import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {useEvents} from "../../../lib/useEvents";

export function useDeleteSirenSMSConfig() {
    const [deleting, setDeleting] = useState(false);
    const {emit} = useEvents();

    const deleteConfig = useCallback(async (id: string, context?: {clientID?: string; departmentID?: string}) => {
        setDeleting(true);
        try {
            await platformAPI.delete(`api/siren/sms-config/${id}`);
            emit("siren:smsConfig:changed", {clientID: context?.clientID, departmentID: context?.departmentID, deleted: true});
        } finally {
            setDeleting(false);
        }
    }, [emit]);

    return {deleteConfig, deleting};
}
